import React, { memo, useEffect, useState } from "react"
import Link from "next/link"
import CardChannel from "components/CardChannel"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"

// eslint-disable-next-line react/display-name
const SwiperChannel = memo(({ name, events, id }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <>
      <h2 className="relative text-xl leading-6 font-semibold">
        <Link href={`/danh-muc/${id}`}>
          <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8">
            <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">{name}</span>
            <div
              className={`text-primary text-sm sm:text-base md:text-xl font-extrabold whitespace-nowrap leading-[30px] flex items-center gap-[10px] ${
                !isMobile ? "" : ""
              }`}
            >
              <span className="text-sm font-normal">Xem thêm</span>
              {/* {!isMobile && (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 18L18 12L12 6" stroke="#1877F2" strokeWidth="2" />
                  <path d="M6 18L12 12L6 6" stroke="#1877F2" strokeWidth="2" />
                </svg>
              )} */}
            </div>
          </div>
        </Link>
      </h2>
      <div className="relative wapper__swiper__custom">
        <Swiper
          key={"liveshow"}
          slidesPerView={4.8}
          slidesPerGroup={4}
          spaceBetween={24}
          modules={[Navigation]}
          className="swiper_card_horizontal"
          navigation={true}
          breakpoints={{
            0: {
              slidesPerView: 2.1,
              slidesPerGroup: 2,
              spaceBetween: 12
            },
            768: {
              slidesPerView: 2.75,
              slidesPerGroup: 3
            },
            890: {
              slidesPerView: 3.2,
              slidesPerGroup: 3
            },
            1050: {
              slidesPerView: 3.8,
              slidesPerGroup: 4
            },
            1280: {
              slidesPerView: 4.5,
              slidesPerGroup: 4
            }
          }}
        >
          {events?.length > 0 &&
            events?.map((item) => {
              const { id } = item
              item.thumbnail_horizontal = item.thumbnail
              return (
                <SwiperSlide key={id}>
                  <CardChannel {...item} isChannel={true} showTime={false} />
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>
    </>
  )
})

export default SwiperChannel
